var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3448 0H1.65517C0.741046 0 0 0.741046 0 1.65517V28.3448C0 29.259 0.741046 30 1.65517 30H16.0345V18.3983H12.1293V13.8569H16.0345V10.5155C16.0345 6.64138 18.4034 4.53103 21.8586 4.53103C23.023 4.5285 24.1866 4.5872 25.3448 4.7069V8.7569H22.9655C21.0828 8.7569 20.7155 9.64655 20.7155 10.9603V13.8517H25.2155L24.631 18.3931H20.6897V30H28.3448C29.259 30 30 29.259 30 28.3448V1.65517C30 0.741046 29.259 0 28.3448 0Z",
    fill: "#FDD65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5f98878638a823ae2d287af51dc4e447.svg";
export { ForwardRef as ReactComponent };